export enum Path {
  HOME = '/',
  DAY_PLAN = '/day-plan',
  DAY_PLAN_LESSON = '/day-plan/:lessonId',
  REQUESTS = '/requests',
  CUSTOMERS = '/customers',
  CUSTOMERS_DRAWER = '/customers/:customerId',
  CUSTOMER_DETAIL = '/customer/:customerId',
  RECEIPTS = '/receipts',
  RECEIPTS_DETAIL = '/receipts/:receiptId',
  POS_CLOSINGS = '/pos-closings',
  INSTRUCTORS = '/instructors',
  INSTRUCTOR_AVAILABILITY = '/instructor-availability',
  INSTRUCTOR_SALARY = '/instructor-salary',
  INSTRUCTOR_SALARY_DETAIL = '/instructor-salary/:instructorId',
  PRODUCTS = '/products',
  SETTINGS = '/settings',
}
